import React from "react";

import { useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Container from "@mui/material/Container";

const TagMeetingHeader = ({ headerName }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const redirectToHome = () => {
    navigate("/handle-meetings");
  };
  return (
    <AppBar position="sticky" className="app_header">
      <Container maxWidth="lg">
        <Toolbar>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={goBack}
            >
              <ArrowBackIosIcon
                className="app_bar_content"
                sx={{ fontSize: "18px !important" }}
              />
            </IconButton>
          </Box>
          <Typography
            variant="h6"
            component="div"
            className="app_bar_content header "
            sx={{ flexGrow: 1 }}
          >
            {headerName}
          </Typography>
          <Box>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="account of current user"
              onClick={redirectToHome}
            >
              <HomeOutlinedIcon className="app_bar_content" />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default TagMeetingHeader;
